import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

// AsyncThunk
export const autoTranslateLanguageFunc = createAsyncThunk(
  "languages/autoTranslate",
  async ({ id, payload }, thunkAPI) => {
    try {
      const response = await api.post(
        `dashboard/languages/${id}/auto-translate`,
        payload
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice
const autoTranslateLanguageSlicer = createSlice({
  name: "autoTranslateLanguage",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(autoTranslateLanguageFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(autoTranslateLanguageFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(autoTranslateLanguageFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default autoTranslateLanguageSlicer.reducer;
